define('views/LayoutWithSidebarView',['require','exports','module','views/BaseView','ThemesHelper','ldsh!../templates/main-layout-with-sidebar'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");
    var ThemesHelper = require('ThemesHelper');
    var LayoutView = BaseView.extend({
        template: require("ldsh!../templates/main-layout-with-sidebar"),
        el: "main",

        serialize: function () {
            return {
                globalAssetsURL: ThemesHelper.getCurrentThemeGlobalURL()
            };
        }
    });

    module.exports = LayoutView;
});

